import { Icon } from "@iconify/react/dist/iconify.js";

export function SubmittingQuotationRequest() {
  return (
    <div className="grid place-content-center h-full">
      <div className="grid gap-3 rounded-md p-3 shadow-md">
        <div className="grid gap-1 place-items-center">
          <Icon icon="mingcute:loading-line" className="text-5xl animate-spin" />
          <span className="text-center">Submitting Quotation Request</span>
          <br />
          <small className="text-center">This may take a few seconds.</small>
          <small className="text-center">Please don't close this window.</small>
        </div>
      </div>
    </div>
  );
}